// extracted by mini-css-extract-plugin
export default {"items":"AutoSlider_items__vrCYN"};